import React from 'react'

import Grid from '../../../../components/Grid'

import { TItem } from '../../types'
import ELocale from '../../../../types/locales'

const LegalAreaItem: React.FC<{ item: TItem; locale: ELocale }> = (props) => {
  const href: string =
    typeof props.item.url === 'string'
      ? props.item.url
      : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- this is needed because i didn't know how to type `item` correctly
        props.item.url[props.locale]!
  return (
    <Grid.Col as="li" key={props.item.label} className="flex-none mx-16">
      <a href={href}>{props.item.label}</a>
    </Grid.Col>
  )
}

export { LegalAreaItem as default }
